// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"164":"a6ca1393","488":"b69bc8bb"}[chunkId] + ".chunk.js";
};